"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormContainer = void 0;
var React = __importStar(require("react"));
var Forms_1 = require("../../Components/Forms");
var FormContainer = /** @class */ (function (_super) {
    __extends(FormContainer, _super);
    function FormContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.allStatesProvinces = {};
        _this.currentStatesProvinces = [];
        _this.allSubReasons = {};
        _this.currentSubReasons = [];
        _this.setInitialState = function () {
            _this.setState(_this.getInitialState());
        };
        _this.getInitialState = function () {
            var inputs = _this.props.inputs;
            var reducedInputs = inputs.reduce(function (acc, currentValue) {
                acc[currentValue.name] = {
                    hasError: false,
                    value: currentValue.value || ""
                };
                return acc;
            }, {});
            reducedInputs = __assign(__assign({}, reducedInputs), { checkBox: {
                    hasError: false,
                    isSelected: false
                }, submitStatus: 1 /* SubmitStatusType.Error */, errorMessage: null });
            return reducedInputs;
        };
        _this.handleInputChange = function (event) {
            var _a;
            var formFields = _this.props.formFields;
            var target = event.target;
            var inputValue = target.value;
            var name = target.name;
            if (name === formFields.Reason) {
                _this.handleReasonChange(inputValue);
            }
            _this.setState((_a = {},
                _a[name] = {
                    hasError: false,
                    value: inputValue
                },
                _a));
        };
        _this.handleReasonChange = function (reason) {
            var _a;
            var formFields = _this.props.formFields;
            _this.currentSubReasons = _this.allSubReasons[reason].value;
            _this.setState((_a = {},
                _a[formFields.Reasons] = {
                    hasError: false,
                    value: ""
                },
                _a));
        };
        _this.checkBoxPolicyClick = function (isChecked) {
            _this.setState({
                checkBox: {
                    hasError: false,
                    isSelected: isChecked,
                }
            });
        };
        _this.state = _this.getInitialState();
        return _this;
    }
    FormContainer.prototype.render = function () {
        var _a = this.props, children = _a.children, submitLabel = _a.submitLabel, explanationText = _a.explanationText;
        var formProps = {
            explanationText: explanationText,
            handleCheckBox: this.checkBoxPolicyClick,
            handleInputChange: this.handleInputChange,
            hasErrorCheckBox: this.state.checkBox.hasError,
            inputs: this.createFormProperties(),
            isSelectedCheckBox: this.state.checkBox.isSelected,
            validateInputs: this.validateInputs.bind(this),
            onResetClick: this.setInitialState,
            errorMessage: this.state.errorMessage,
            submitLabel: submitLabel,
        };
        var childrenWithProps = React.Children.map(children, function (child) {
            return React.cloneElement(child, formProps);
        });
        return (React.createElement(React.Fragment, null, childrenWithProps));
    };
    FormContainer.prototype.createFormProperties = function () {
        var _this = this;
        var _a = this.props, reasons = _a.reasons, genders = _a.genders, inputs = _a.inputs, formFields = _a.formFields;
        var inputObject = inputs.reduce(function (acc, currentValue) {
            acc[currentValue.name] = __assign(__assign({}, currentValue), _this.state[currentValue.name]);
            return acc;
        }, {});
        formFields.Reason && (inputObject[formFields.Reason].options = reasons);
        formFields.Gender && (inputObject[formFields.Gender].options = genders);
        if (formFields.StateProvince) {
            inputObject[formFields.StateProvince].readOnly = this.currentStatesProvinces.length === 0;
            inputObject[formFields.StateProvince].options = this.currentStatesProvinces;
        }
        if (formFields.SubReason) {
            inputObject[formFields.SubReason].disabled = this.currentSubReasons.length === 0;
            inputObject[formFields.SubReason].options = this.currentSubReasons;
        }
        return inputObject;
    };
    FormContainer.prototype.validateInputs = function () {
        var _this = this;
        var newState = {};
        var _a = this.props, inputs = _a.inputs, formFields = _a.formFields;
        var isValid = true;
        inputs.forEach(function (currentValue) {
            var inputState = _this.state[currentValue.name];
            if (currentValue.required && (inputState.value.length === 0 || !inputState.value.trim())) {
                newState[currentValue.name] = __assign({}, inputState);
                newState[currentValue.name].hasError = true;
                isValid = false;
            }
        });
        // if (!this.state.checkBox.isSelected) {
        //     newState.checkBox = { ...this.state.checkBox };
        //     newState.checkBox.hasError = true;
        //     isValid = false;
        // }
        if (formFields.Email) {
            var emailInput = this.state[formFields.Email];
            if (newState.hasOwnProperty(formFields.Email) && newState[formFields.Email].hasError) {
                newState[formFields.Email].hasFormatError = false;
            }
            else {
                if (!(0, Forms_1.validateEmail)(emailInput.value)) {
                    newState[formFields.Email] = __assign({}, emailInput);
                    newState[formFields.Email].hasError = true;
                    newState[formFields.Email].hasFormatError = true;
                    isValid = false;
                }
            }
        }
        if (formFields.Password) {
            var passwordInput = this.state[formFields.Password];
            if (newState.hasOwnProperty(formFields.Password) && newState[formFields.Password].hasError) {
                newState[formFields.Password].hasFormatError = false;
            }
            else {
                if (!(0, Forms_1.validatePassword)(passwordInput.value)) {
                    newState[formFields.Password] = __assign({}, passwordInput);
                    newState[formFields.Password].hasError = true;
                    newState[formFields.Password].hasFormatError = true;
                    isValid = false;
                }
            }
        }
        if (formFields.RepeatPassword) {
            if (newState.hasOwnProperty(formFields.RepeatPassword) && newState[formFields.RepeatPassword].hasError) {
                newState[formFields.RepeatPassword].hasFormatError = false;
            }
            else {
                var repeatPasswordInput = this.state[formFields.RepeatPassword];
                if (repeatPasswordInput.value !== this.state[formFields.Password].value) {
                    newState[formFields.RepeatPassword] = __assign({}, repeatPasswordInput);
                    newState[formFields.RepeatPassword].hasError = true;
                    newState[formFields.RepeatPassword].hasFormatError = true;
                    isValid = false;
                }
            }
        }
        this.setState(newState);
        return isValid;
    };
    return FormContainer;
}(React.Component));
exports.FormContainer = FormContainer;
